"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rectangle = void 0;
var react_1 = __importDefault(require("react"));
exports.Rectangle = function (props) {
    var cx = props.cx, cy = props.cy, stroke = props.stroke;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", __assign({ x: cx - 15.3, y: cy - 15.3, width: 490, height: 490 }, { fill: stroke, opacity: 0.3 }, { viewBox: '0 0 1024 1024', className: 'hover-shape' }),
            react_1.default.createElement(RectangleSvgPath, null)),
        react_1.default.createElement("svg", __assign({ x: cx - 10, y: cy - 10, width: 315, height: 315 }, { fill: stroke }, { viewBox: '0 0 1024 1024' }),
            react_1.default.createElement(RectangleSvgPath, null))));
};
var RectangleSvgPath = function () { return react_1.default.createElement("path", { d: 'M8 22 L8 42 L56 42 L56 22 Z' }); };
//# sourceMappingURL=Rectangle.js.map